module.exports = __webpack_public_path__ + "img/073419.038efd2c.png";